import createVueApp from '@phoenix/createVueApp';
import StockNotifyPanel from '@maison/components/product/StockNotifyPanel.vue';

const app = createVueApp({}, true);
app.component('StockNotifyPanel', StockNotifyPanel);
app.mount('#phoenix-stock-notify-panel');
